import { createContext } from 'react';
import { Notification, NotificationState, NotificationFilter } from '@/types/notification';

export interface NotificationContextType extends NotificationState {
  addNotification: (notification: Omit<Notification, 'id' | 'timestamp' | 'isRead'>) => Promise<void>;
  markAsRead: (notificationId: string) => Promise<void>;
  markAllAsRead: () => Promise<void>;
  removeNotification: (notificationId: string) => Promise<void>;
  clearExpired: () => void;
  getFilteredNotifications: (filter: NotificationFilter) => Notification[];
  refreshNotifications: () => Promise<void>;
}

export const NotificationContext = createContext<NotificationContextType | null>(null);